<proffeo-ui-dialog [title]="'company-groups.modals.select-users-modal-title' | translate">
  <div class="flex flex-col w-full h-full gap-2">
    <proffeo-api-error-banner [errors]="localApiErrorHandler.errors()" />
    @if (groupUsers()?.length) {
      <proffeo-select-users-list
        [(selectedUsers)]="selectedUsers"
        [lockedUserIds]="[lockedUser()]"
        [originalUsers]="groupUsers()"
      ></proffeo-select-users-list>
    }
  </div>
  <div
    dialog-actions
    class="flex w-full justify-end gap-2"
  >
    <proffeo-ui-button
      [disabled]="localApiErrorHandler.isSaving()"
      variant="primary"
      matDialogClose
      text="close"
    ></proffeo-ui-button>
    <proffeo-ui-button
      (clicked)="save()"
      [disabled]="localApiErrorHandler.isSaving()"
      variant="accent"
      text="save-and-close"
    ></proffeo-ui-button>
  </div>
</proffeo-ui-dialog>
